export default __webpack_public_path__ + "static/media/sorektaimemecoinupdated.036d0473.png";